import React from "react";
import { AddAdditionalDocumentModal } from "features/AdditionalDocuments";
import { uploadAssignmentTemplateSPV } from "./actions";

const AddAssignmentTemplateSPVModal = ({ onSubmitted, dealerId, ...props }) => (
  <AddAdditionalDocumentModal
    {...props}
    submitAction={uploadAssignmentTemplateSPV}
    triggerText="Upload New Assignment Template from SPV"
    headerText="New Assignment Template from SPV"
    onSubmitted={onSubmitted}
    dealerId={dealerId}
  />
);

export default AddAssignmentTemplateSPVModal;
